import none from './none-icon.png'
import blur from './blur-icon.png'
import previous from './previous-icon.png'
import previousDisabled from './previous-disabled-icon.png'
import { useDispatch, useSelector } from 'react-redux'
import {
  blurVirtualBackground,
  removeVirtualBackground,
  setVirtualBackground,
} from './actions'
import './DropdownOptions.css'
import { selectPreviousImage, selectVbImage } from './reducer'
import { VB_IMAGE_TYPES } from './constants'

const DropdownOptions = ({ zaConfigIsPending }) => {
  const dispatch = useDispatch()
  const previousImage = useSelector(selectPreviousImage)
  const vbImage = useSelector(selectVbImage)

  const onClickNone = () => {
    if (vbImage?.type === VB_IMAGE_TYPES.none) return
    dispatch(removeVirtualBackground())
  }

  const onClickBlur = () => {
    if (vbImage?.type === VB_IMAGE_TYPES.blur) return
    dispatch(blurVirtualBackground())
  }

  const onClickPrevious = () => {
    if (!previousImage) return

    if (previousImage.type === VB_IMAGE_TYPES.blur) {
      dispatch(blurVirtualBackground({ popPreviousImage: true }))
    } else if (previousImage.type === VB_IMAGE_TYPES.none) {
      dispatch(removeVirtualBackground({ popPreviousImage: true }))
    } else {
      dispatch(
        setVirtualBackground({ image: previousImage, popPreviousImage: true })
      )
    }
  }

  return (
    <div className="VB__dropdown">
      <h4 className="VB__dropdown-text VB__dropdown-title">Set to</h4>

      <button
        className={`VB__dropdown-option ${!previousImage ? 'disabled' : ''}`}
        aria-label="previous"
        onClick={onClickPrevious}
        disabled={zaConfigIsPending || !previousImage}
      >
        <img src={previousImage ? previous : previousDisabled} alt="previous" />
        <p className={`VB__dropdown-text ${!previousImage ? 'disabled' : ''}`}>
          Previous
        </p>
      </button>

      <button
        className="VB__dropdown-option"
        aria-label="none"
        onClick={onClickNone}
        disabled={zaConfigIsPending}
      >
        <img src={none} alt="none" />
        <p className="VB__dropdown-text">None</p>
      </button>

      <button
        className="VB__dropdown-option"
        aria-label="blur"
        onClick={onClickBlur}
        disabled={zaConfigIsPending}
      >
        <img src={blur} alt="blur" />
        <p className="VB__dropdown-text">Blur</p>
      </button>
    </div>
  )
}

export default DropdownOptions
